import React, { useState, useEffect, useCallback } from 'react';
import { api } from '../api';
import ItemCard from '../components/ItemCard';
import ModalConfirm from '../components/ModalConfirm';
import Modal from '../components/ui/Modal';
import Field, { FormRow } from '../components/ui/Field';
import Estado from '../components/ui/Estado';
import EmptyState from '../components/ui/EmptyState';
import PageHeader from '../components/ui/PageHeader';
import { toast } from '../components/Toast';

export default function Armazens() {
  const [lista, setLista] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erroCarga, setErroCarga] = useState('');
  const [form, setForm] = useState({ nome: '', cidade: '' });
  const [criando, setCriando] = useState(false);
  const [editando, setEditando] = useState(null);
  const [erroModal, setErroModal] = useState('');
  const [excluindo, setExcluindo] = useState(null);
  const [salvando, setSalvando] = useState(false);

  const carregar = useCallback(async () => {
    setCarregando(true);
    setErroCarga('');
    try {
      setLista(await api.getArmazens() || []);
    } catch (err) {
      setErroCarga(err.message || 'Não foi possível carregar os armazéns.');
    } finally {
      setCarregando(false);
    }
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  const salvar = async (e) => {
    e.preventDefault();
    setSalvando(true);
    try {
      await api.criarArmazem(form);
      setForm({ nome: '', cidade: '' });
      setCriando(false);
      toast('Armazém criado.', 'success');
      carregar();
    } catch (err) { toast(err.message, 'error'); }
    finally { setSalvando(false); }
  };

  const salvarEdicao = async (e) => {
    e?.preventDefault();
    setErroModal('');
    try {
      await api.editarArmazem(editando.id, { nome: editando.nome, cidade: editando.cidade });
      setEditando(null);
      toast('Armazém atualizado.', 'success');
      carregar();
    } catch (err) { setErroModal(err.message); }
  };

  const confirmarExclusao = async () => {
    try {
      await api.excluirArmazem(excluindo.id);
      setExcluindo(null);
      toast('Armazém removido.', 'success');
      carregar();
    } catch (err) {
      setExcluindo(null);
      toast(err.message, 'error');
    }
  };

  return (
    <div>
      <PageHeader
        titulo="Armazéns"
        icone="armazem"
        descricao="Opcional. Use se guarda a produção em locais diferentes e quer o saldo de cada um."
        acao={{ label: 'Novo armazém', icone: 'adicionar', onClick: () => setCriando(true) }}
      />

      <div className="card">
        <div className="secao-titulo">
          <h2>Armazéns cadastrados</h2>
          {lista.length > 0 && <span className="contador">{lista.length}</span>}
        </div>

        <Estado carregando={carregando} erro={erroCarga} aoTentarNovamente={carregar} itens={3}>
          {lista.length === 0 ? (
            <EmptyState
              compacto
              icone="armazem"
              titulo="Nenhum armazém cadastrado"
              descricao="Você pode registrar produção e vendas sem armazém. Cadastre apenas se quiser controlar o saldo por local de armazenagem."
              acao={{ label: 'Novo armazém', onClick: () => setCriando(true) }}
            />
          ) : lista.map(a => (
            <ItemCard key={a.id} onEdit={() => { setEditando({ ...a }); setErroModal(''); }} onDelete={() => setExcluindo(a)}>
              <div className="item-conteudo">
                <div className="item-titulo">{a.nome}</div>
                <div className="item-meta">{a.cidade}</div>
              </div>
            </ItemCard>
          ))}
        </Estado>
      </div>

      {criando && (
        <Modal titulo="Novo armazém" onClose={() => setCriando(false)} largura={480}>
          <form onSubmit={salvar}>
            <FormRow>
              <Field label="Nome" obrigatorio>
                <input value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })}
                  required placeholder="Ex: Silo da sede, Cooperativa" />
              </Field>
              <Field label="Cidade" obrigatorio>
                <input value={form.cidade} onChange={e => setForm({ ...form, cidade: e.target.value })} required />
              </Field>
            </FormRow>
            <div className="actions modal-rodape">
              <button type="button" className="btn-secondary" onClick={() => setCriando(false)}>Cancelar</button>
              <button type="submit" className="btn-primary" disabled={salvando}>
                {salvando ? 'Salvando...' : 'Cadastrar armazém'}
              </button>
            </div>
          </form>
        </Modal>
      )}

      {editando && (
        <Modal titulo="Editar armazém" onClose={() => setEditando(null)} largura={480}>
          {erroModal && <div className="aviso aviso--erro">{erroModal}</div>}
          <form onSubmit={salvarEdicao}>
            <FormRow>
              <Field label="Nome" obrigatorio>
                <input value={editando.nome} onChange={e => setEditando({ ...editando, nome: e.target.value })} required />
              </Field>
              <Field label="Cidade" obrigatorio>
                <input value={editando.cidade} onChange={e => setEditando({ ...editando, cidade: e.target.value })} required />
              </Field>
            </FormRow>
            <div className="actions modal-rodape">
              <button type="button" className="btn-secondary" onClick={() => setEditando(null)}>Cancelar</button>
              <button type="submit" className="btn-primary">Salvar</button>
            </div>
          </form>
        </Modal>
      )}

      {excluindo && (
        <ModalConfirm
          titulo="Excluir armazém"
          mensagem={<>Excluir <strong>{excluindo.nome}</strong>?</>}
          aviso="Armazéns com produção ou vendas vinculadas não podem ser excluídos."
          onConfirm={confirmarExclusao}
          onCancel={() => setExcluindo(null)}
        />
      )}
    </div>
  );
}
